function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultConnectionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "46.774 84.531 388.534 287.138",
    width: 388.534,
    height: 287.138,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "var(--accents-color)"
    },
    x: 155.314,
    y: 84.531,
    width: 172.785,
    height: 83.544,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "var(--accents-color)"
    },
    x: 287.082,
    y: 300,
    width: 148.226,
    height: 71.669,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "var(--accents-color)"
    },
    x: 46.774,
    y: 300,
    width: 148.226,
    height: 71.669,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "var(--txt-color)"
    },
    d: "M 238.604 168.003 C 239.571 167.936 234.104 223.192 150.161 232.606 C 100 238.232 103.801 300.153 105.99 300"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "var(--txt-color)"
    },
    d: "M 362.856 300.033 C 363.823 300.1 358.356 244.844 274.413 235.43 C 224.252 229.804 229.972 167.69 232.161 167.843",
    transform: "matrix(-1, 0, 0, -1, 602.001404, 467.842804)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultConnectionDark);
export default __webpack_public_path__ + "static/media/defaultConnectionDark.f71cb283cd74b9e3937b01ee4617cdbb.svg";
export { ForwardRef as ReactComponent };